import SpecialHoursConfig from './SpecialHoursConfig.view';

export default SpecialHoursConfig;
